import { jiraIssueUrl } from '../lib/jira';

// Renders a Jira issue key (e.g. "A1EE-334") as an external link to the issue.
// Opens in a new tab; `rel="noopener noreferrer"` per the repo's external-link convention.
export function JiraLink({ issueKey, className }: { issueKey: string; className?: string }) {
  return (
    <a
      href={jiraIssueUrl(issueKey)}
      target="_blank"
      rel="noopener noreferrer"
      className={className ?? 'font-mono underline-offset-2 hover:underline'}
    >
      {issueKey}
    </a>
  );
}
